import styled, { createGlobalStyle } from 'styled-components';
import tw from 'twin.macro';
import * as S from '@styles/chat/chat.style';
import { getHoveredElementBackground } from '@styles/globalsStyles';
import {
  CHAT_ROOM_Z_INDEX,
  STUDENT_SELECTOR_CONTENT_CLASS_NAME,
} from 'constants/chat';

export const ScheduledMessagePopupHeader = S.ChatRoomHeaderLayout;

export const ScheduledMessagePopupFooter = styled.div`
  & {
    ${tw`flex items-center justify-between px-4 py-3 border-t border-solid border-my-gray-80 bg-my-gray-100`}

    > div:last-child {
      ${tw`flex items-center gap-2`}
    }
  }
`;

export const ScheduledMessageForm = styled.form`
  & {
    ${tw`flex flex-col flex-grow min-h-[1px]`}

    > div.wrapper {
      ${tw`flex-grow min-h-[1px] flex flex-col`}
    }
  }
`;

export const StudentSelectorGlobalStyle = createGlobalStyle`
  [data-radix-popper-content-wrapper]:has(> .${STUDENT_SELECTOR_CONTENT_CLASS_NAME}){
    ${tw`w-[12rem] h-fit bg-white`}
      z-index: ${CHAT_ROOM_Z_INDEX + 2} !important;
      min-width: auto !important;
      box-shadow: 0px 8px 24px 0px rgba(23, 32, 42, 0.16);

      [data-radix-menu-content] {
        ${tw`w-full overflow-y-auto h-fit max-h-[24rem]`}
        
        
        [data-radix-collection-item] {
          ${tw`cursor-pointer text-body-md-500 items-center flex gap-2 text-my-gray-10 py-[0.62rem] px-4`}
          &:hover {
            background: ${getHoveredElementBackground('var(--gray-100)')};
          }

          > span:first-child {
            ${tw`whitespace-nowrap`}
          }
          > span:last-child {
            ${tw`flex-shrink truncate text-label-sm-500 text-my-gray-50`}
          }
        }
      }
  }
`;

export const StudentSelector = styled.div`
  & {
    ${tw`px-4 py-2 border-b border-solid text-label-md-500 text-my-gray-10 border-my-gray-80`}
    button {
      ${tw`flex gap-1 p-2 py-1 pl-2 pr-1 rounded-lg w-fit text-label-md-500 text-my-gray-10`}
      &:hover {
        background: ${getHoveredElementBackground('var(--gray-100)')};
      }
    }
  }
`;

export const MessageTextArea = styled.div`
  ${tw`flex-grow min-h-[1px]`}
  >textarea {
    ${tw`w-full h-full p-4 resize-none focus-visible:outline-none placeholder:text-body-lg-500 placeholder:text-my-gray-50`}
  }
`;

export const AdvancedForm = styled.div`
  & {
    ${tw`flex flex-col w-full gap-4 p-4 border-t border-solid border-my-gray-80 bg-my-gray-100`}

    .attach-image {
      ${tw`flex flex-col gap-2`}
    }
    .time {
      ${tw`flex flex-col gap-2`}
    }
    .title {
      ${tw`text-label-lg-700 text-my-gray-10`}
    }
  }
`;

export const ScheduledMessageListItem = styled.div`
  & {
    ${tw`flex flex-col w-full gap-2 p-4 border-b border-solid cursor-pointer bg-my-gray-100 border-my-gray-80`}
    &:hover {
      background: ${getHoveredElementBackground('bg-my-gray-100')};
    }

    > div.time,
    div.recipient {
      ${tw`flex justify-between text-label-md-500 text-my-gray-30`}
    }
    > div.content {
      ${tw`w-full text-body-md-500 text-my-gray-10`}
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
`;
